module.exports = __webpack_public_path__ + "media/images/front/sp/treatment-introduction-article/kv-e21e7607ec734d13575e829a08d5cecd.png";